import * as React from "react";
import "./menu-box.less";
import { MenuBoxGroupItem } from "./menu-box-group-item";
import { IProductCategoryModel } from "states/menu/menu.models";
import { SelectBranchModal } from "shared/components/select-branch/select-branch-modal";

export interface IMenuBoxProps {
  categories: IProductCategoryModel[]
}

export function MenuBox({ categories }: IMenuBoxProps) {
  return <>
    <div className={`w-full bg-gray-100 rounded-lg shadow-md lg:px-2.5 xs:px-1 p-2 menu-box  xs:border-none `}>
      <SelectBranchModal />
      {categories?.map((cate) => (<MenuBoxGroupItem key={cate.id} model={cate} />))}
    </div>
  </>;
}
